import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Incoterms = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("incoterms");
  const [data, setData] = useState(undefined);
  const [termCode, setTermCode] = useState("");
  const [termDesc, setTermDesc] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [Active, setActive] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyTermCode, setEmptyTermCode] = useState(false);
  const [emptyTermDesc, setEmptyTermDesc] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setTermCode("");
    setTermDesc("");
  };

  function setSelectedRow(rowid) {
    console.log(rowid);

    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        console.log(selectRowData);
        setSelectRowData(selectRowData);
        setTermCode(
          selectRowData.incoterm.term_code
            ? selectRowData.incoterm.term_code
            : ""
        );
        setTermDesc(
          selectRowData.incoterm.term_description
            ? selectRowData.incoterm.term_description
            : ""
        );
        if (
          selectRowData.incoterm.active_status
            ? selectRowData.incoterm.active_status == 1
            : ""
        ) {
          setIsChecked(true);
        } else {
          setIsChecked(false);
        }
        setBtnActive(false);
      });
  }

  const handleSave = async (event) => {
    event.preventDefault();

    if (termCode.length == 0) {
      toast.error("Incoterms Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyTermCode(true);
      setEmptyInput(true);
    } else {
      setEmptyTermCode(false);
    }

    if (termDesc.length == 0) {
      toast.error("Incoterms Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyTermDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyTermDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        term_code: termCode,
        term_description: termDesc,
        active_status: isChecked ? 1 : 0,
      };
      const duplicate = await data.some((el) => el.TermCode == termCode);
      if (duplicate !== true) {
        axios
          .post(`${baseUrl}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This Incoterms code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        term_code: termCode,
        term_description: termDesc,
        active_status: isChecked ? 1 : 0,
      };
      axios
        .post(
          `${baseUrl}${pageComponent}/update/${selectRowData.incoterm.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.incoterms);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${baseUrl}${pageComponent}/destroy/${selectRowData.incoterm.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Term Code", "Term Desc", "Active"];
  const columns = ["term_code", "term_description", "active_status"];
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>TermCode</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="CFR"
                    name="termCode"
                    value={termCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyTermCode == true ? "border-red2" : ""}
                    onChange={(e) => setTermCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>TermDesc</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="COST AND FREIGHT"
                    name="termDesc"
                    value={termDesc}
                    className={emptyTermDesc == true ? "border-red2" : ""}
                    onChange={(e) => setTermDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3 " controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="Active"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </Form.Group>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Incoterms;
